import styled from 'styled-components/macro'
import { Rect } from './Rect'

export const AreaSelect = styled(Rect)`
  border: 1px dashed #FFF;
  mix-blend-mode: difference;
`
